'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/hourAfter.js
// module id = 163
// module chunks = 0